import { Component, OnInit } from "@angular/core";
import { TranslationService } from "app/services/translation.service";
import { FirestoreService } from "app/services/firestore.service";
import { Subscription } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-mv-tilesets",
  templateUrl: "./mv-tilesets.component.html",
  styleUrls: ["./mv-tilesets.component.scss"],
})
export class MvTilesetsComponent implements OnInit {
  public current_index: number = -1;
  public graphics;
  public i18n;
  public current_language;
  private subscriptions: Subscription[] = [];
  private graphics_sub: Subscription;
  public free: boolean;

  constructor(
    private translation_service: TranslationService,
    private firestore: FirestoreService,
    private router: Router
  ) {}

  ngOnInit() {
    // get dictionary
    this.subscriptions.push(
      this.translation_service.current_dictionary_observable.subscribe(
        (dictionary) => {
          this.i18n = dictionary;
        }
      )
    );
    this.i18n = this.translation_service.getDictionary();

    // get current language
    this.subscriptions.push(
      this.translation_service.current_lang_observable.subscribe((lang) => {
        this.current_language = lang;
      })
    );
    this.current_language = this.translation_service.getLanguage();

    // observe current route
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) this.fetchData();
    });
    this.fetchData();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    if (this.graphics_sub != undefined) this.graphics_sub.unsubscribe;
  }

  changeContent(index: number) {
    this.current_index = index;
  }

  fetchData() {
    // fetch ressi data
    if (this.graphics_sub != undefined) {
      this.graphics_sub.unsubscribe;
    }
    switch (this.router.url) {
      case "/engine-free":
        this.graphics_sub = this.firestore.getFreeTiles().subscribe((data) => {
          this.free = true;
          this.graphics = data;
        });
        break;
      case "/mv-tilesets":
        this.graphics_sub = this.firestore.getMvTiles().subscribe((data) => {
          this.free = false;
          this.graphics = data;
        });
        break;
    }
    console.log(this.graphics);
  }
}
